import {action, computed} from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    IGroupedOption,
    inject,
    InputDropdownMultiSelectFilter
} from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayFiltersStore } from './DisplayFiltersStore';
import { DisplayListViewModel } from './DisplayListViewModel';
import {IDisplayCellProps} from "../Displays/DisplayCells";

export interface ISoftwareVersionsFilterProps {
    readonly vm: DisplayListViewModel;
}

@autoinject
@observer
export class SoftwareVersionsFilter extends React.Component<ISoftwareVersionsFilterProps> {
    public render() {
        const { displayFilter, filterOptions, onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="Software Versions"
                groupedOptions={this.groupedSoftwareVersions}
                disabled={this.props.vm.disabledFilters.includes('currentSoftwareVersions')}
                filter={displayFilter.currentSoftwareVersions}
                style={{
                    minWidth: 400,
                }}
                onToggle={onFilterDropdownToggle}
                onChange={this.onChange}
                openOnMount
                useGroupOptions
            />
        );
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    @bind
    @action
    private onChange(value: string[] | undefined) {
        const { displayFilter } = this.props.vm;
        displayFilter.currentSoftwareVersions = value;
    }
    
    @computed
    private get groupedSoftwareVersions(): IGroupedOption<string>[] {
        const groupedDict: { [key: string]: string[] } = {};
        let options = this.displayFiltersStore.all?.currentSoftwareVersions;
        if(options) {
            options.forEach(item => {
                const group = item.split('.')[0];
                if (!groupedDict[group]) {
                    groupedDict[group] = [];
                }
                groupedDict[group].push(item);
            });

            // Sort the items in each group in descending order, considering the edge case
            Object.keys(groupedDict).forEach(group => {
                groupedDict[group].sort((a, b) => {
                    const aParts = a.split('.');
                    const bParts = b.split('.');
                    const aLastPart = aParts[aParts.length - 1].padStart(2, '0');
                    const bLastPart = bParts[bParts.length - 1].padStart(2, '0');
                    aParts[aParts.length - 1] = aLastPart;
                    bParts[bParts.length - 1] = bLastPart;
                    return bParts.join('.').localeCompare(aParts.join('.'));
                });
            });

            const groupedArray = Object.keys(groupedDict).map(key => ({
                group: key + '.x.xx',
                options: groupedDict[key]
            })); 

            return groupedArray.reverse();
        }
        
        return [];
    }

    @inject
    private readonly displayFiltersStore!: DisplayFiltersStore;
}
